
define('text!js-translation.json',[],function () { return '{"Apply Rewards":"Apply DFM-Points","Collect your parcels here":"XXX","Out of stock":"Sold Out","Your shipping option selection is invalid. Please review the shipping information.":"Your shipping option selection is invalid. Please review your shipping information."}';});

